import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { formatDate } from "../../../../utils/date-converter";

const SalesOrderPDFInfo = ({ salesOrder, contact }) => {
  const renderAddressString = (addressValues) => {
    let result = "";

    if (Array.isArray(addressValues)) {
      addressValues.forEach((item) => {
        if (item.length > 0) {
          result = result + item + ", ";
        }
      });
    } else {
      const keys = Object.keys(addressValues);
      keys.forEach((key) => {
        if (addressValues[key].length > 0) {
          result = result + addressValues[key] + ", ";
        }
      });
    }
    if (result.trim().length === 0) {
      return "-";
    }
    // remove whitespace and last comma
    return result.trim().slice(0, -1);
  };

  const leftHeader = [
    "รหัสลูกค้า / Customer ID",
    "ชื่อลูกค้า / Customer Name",
    "ที่อยู่ / Address",
    "เลขผู้เสียภาษี / Tax ID",
    "เบอร์โทรศัพท์ / Phone",
    "แฟกซ์ / Fax",
    "อีเมล / Email",
  ];

  const leftInfo = [
    salesOrder?.contact_document_id || "-",
    contact?.contact_name || "-",
    renderAddressString(salesOrder?.customer?.billing_address || {}) || "",
    contact?.identity_no || "-",
    salesOrder?.customer?.phone || "-",
    salesOrder?.customer?.fax || "-",
    salesOrder?.customer?.email || "-",
  ];

  const rightHeader = [
    "เลขที่เอกสาร / Document No.",
    "อ้างอิงถึง / Ref. Document",
    "พนักงานขาย / Salesperson",
    "วันที่ออกเอกสาร / Issue date",
    "ใช้ได้ถึง / Due Date",
    "วันกำหนดส่งของ / Delivery Date",
    "เครดิต / Credit",
  ];

  const rightInfo = [
    salesOrder?.document_id || "-",
    salesOrder?.reference_document_id &&
    salesOrder?.reference_document_id.length > 0
      ? salesOrder?.reference_document_id
          .map((ref) => ref.reference_document_id)
          .join(", ")
      : "-",
    salesOrder?.created_by && salesOrder?.employee_list
      ? salesOrder?.employee_list.map(
          (employee) => employee?.first_name + " " + employee?.last_name
        )[0]
      : "-",
    formatDate(salesOrder?.issue_date) || "-",
    formatDate(salesOrder?.due_date) || "-",
    formatDate(salesOrder?.delivery_date) || "-",
    salesOrder?.credit_day ? salesOrder?.credit_day + " วัน" : "-",
  ];

  return (
    <Grid container sx={{ my: 1 }}>
      <Grid item xs={6}>
        {leftHeader.map((name, index) => (
          <Box sx={{ display: "flex" }} key={index}>
            <Typography
              sx={{
                fontSize: 12,
                lineHeight: "24px",
                letterSpacing: "0.15px",
                fontWeight: 600,
                color: "#333333",
                flex: 1,
              }}
            >
              {name}
            </Typography>
            <Typography
              sx={{
                fontSize: 12,
                lineHeight: "24px",
                letterSpacing: "0.15px",
                flex: 1,
                width: "100%",
                wordBreak: "break-word",
              }}
            >
              {leftInfo[index]}
            </Typography>
          </Box>
        ))}
      </Grid>
      <Grid item xs={6}>
        {rightHeader.map((name, index) => (
          <Box sx={{ display: "flex" }} key={index}>
            <Typography
              sx={{
                fontSize: 12,
                lineHeight: "24px",
                letterSpacing: "0.15px",
                fontWeight: 600,
                color: "#333333",
                flex: 1,
              }}
            >
              {name}
            </Typography>
            <Typography
              sx={{
                fontSize: 12,
                lineHeight: "24px",
                letterSpacing: "0.15px",
                flex: 1,
                width: "100%",
                wordBreak: "break-word",
              }}
            >
              {rightInfo[index]}
            </Typography>
          </Box>
        ))}
      </Grid>
    </Grid>
  );
};

export default SalesOrderPDFInfo;
